// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactEditMarkerPopup_contact-edit-popup__8i9N- {
  font-family: var(--website-font);
  padding-bottom: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 200px;
  padding: 10px;
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- .ContactEditMarkerPopup_image__0CfHQ {
  position: relative;
  margin: 10px;
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- .ContactEditMarkerPopup_image__0CfHQ button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 10px;
  right: -10px;
  height: 30px;
  width: 30px;
  border: none;
  background-color: var(--accent-color);
  border-radius: 20px;
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- .ContactEditMarkerPopup_image__0CfHQ button svg {
  width: 15px;
  height: 15px;
  fill: white;
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- .ContactEditMarkerPopup_image__0CfHQ button:hover {
  background-color: var(--accent-color-dark);
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- .ContactEditMarkerPopup_image__0CfHQ button:hover svg {
  fill: #eee;
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- .ContactEditMarkerPopup_image__0CfHQ button:active {
  background-color: var(--accent-color-x-dark);
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- .ContactEditMarkerPopup_image__0CfHQ button:active svg {
  fill: #ddd;
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- .ContactEditMarkerPopup_image__0CfHQ button:disabled {
  background-color: grey;
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- .ContactEditMarkerPopup_main-text-details__mLujk {
  overflow: hidden;
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- .ContactEditMarkerPopup_accordion-heading__\\+LTcf {
  padding: 6px 0 6px 10px;
  font-size: 1.1em;
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- input,
.ContactEditMarkerPopup_contact-edit-popup__8i9N- textarea {
  margin: 3px;
  padding: 5px 10px;
  border: 1px solid #aaa;
  border-radius: 3px;
  resize: vertical;
  width: 240px;
  box-shadow: 0 0 0 0 var(--accent-color-02-opacity);
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- input:focus, .ContactEditMarkerPopup_contact-edit-popup__8i9N- input:hover,
.ContactEditMarkerPopup_contact-edit-popup__8i9N- textarea:focus,
.ContactEditMarkerPopup_contact-edit-popup__8i9N- textarea:hover {
  border-color: var(--accent-color);
  box-shadow: 0 0 0 3px var(--accent-color-02-opacity);
  outline: none;
}
.ContactEditMarkerPopup_contact-edit-popup__8i9N- .ContactEditMarkerPopup_empty-name-warning__IpvkO {
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/ContactEditMarker/ContactEditMarkerPopup/ContactEditMarkerPopup.module.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,aAAA;AACJ;AACI;EACI,kBAAA;EACA,YAAA;AACR;AACQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,mBAAA;AACZ;AACY;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAChB;AAEY;EACI,0CAAA;AAAhB;AAEgB;EACI,UAAA;AAApB;AAKY;EACI,4CAAA;AAHhB;AAKgB;EACI,UAAA;AAHpB;AAOY;EACI,sBAAA;AALhB;AAUI;EACI,gBAAA;AARR;AAWI;EACI,uBAAA;EACA,gBAAA;AATR;AAYI;;EAEI,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kDAAA;AAVR;AAYQ;;;EAEI,iCAAA;EACA,oDAAA;EACA,aAAA;AATZ;AAaI;EACI,UAAA;AAXR","sourcesContent":[".contact-edit-popup {\n    font-family: var(--website-font);\n    padding-bottom: 5px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: fit-content;\n    min-width: 200px;\n    padding: 10px;\n\n    .image {\n        position: relative;\n        margin: 10px;\n\n        button {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            position: absolute;\n            top: 10px;\n            right: -10px;\n            height: 30px;\n            width: 30px;\n            border: none;\n            background-color: var(--accent-color);\n            border-radius: 20px;\n\n            svg {\n                width: 15px;\n                height: 15px;\n                fill: white;\n            }\n\n            &:hover {\n                background-color: var(--accent-color-dark);\n\n                svg {\n                    fill: #eee;\n                }\n\n            }\n\n            &:active {\n                background-color: var(--accent-color-x-dark);\n\n                svg {\n                    fill: #ddd;\n                }\n            }\n\n            &:disabled {\n                background-color: grey;\n            }\n        }\n    }\n\n    .main-text-details {\n        overflow: hidden;\n    }\n\n    .accordion-heading {\n        padding: 6px 0 6px 10px;\n        font-size: 1.1em;\n    }\n\n    input,\n    textarea {\n        margin: 3px;\n        padding: 5px 10px;\n        border: 1px solid #aaa;\n        border-radius: 3px;\n        resize: vertical;\n        width: 240px;\n        box-shadow: 0 0 0 0 var(--accent-color-02-opacity);\n\n        &:focus,\n        &:hover {\n            border-color: var(--accent-color);\n            box-shadow: 0 0 0 3px var(--accent-color-02-opacity);\n            outline: none;\n        }\n    }\n\n    .empty-name-warning {\n        color: red;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contact-edit-popup": `ContactEditMarkerPopup_contact-edit-popup__8i9N-`,
	"image": `ContactEditMarkerPopup_image__0CfHQ`,
	"main-text-details": `ContactEditMarkerPopup_main-text-details__mLujk`,
	"accordion-heading": `ContactEditMarkerPopup_accordion-heading__+LTcf`,
	"empty-name-warning": `ContactEditMarkerPopup_empty-name-warning__IpvkO`
};
export default ___CSS_LOADER_EXPORT___;
